import React, { FC } from 'react';
import { InfoItem } from '../../../../pages/ServiceManagement';

interface InfoProps {
  infoItems: InfoItem[];
  title: string;
  moreDevices?: string;
  isShowFootnote?: boolean;
}

const defaultProps = {
  moreDevices: '',
  isShowFootnote: false,
};

export const Info: FC<InfoProps> = ({ infoItems, title, moreDevices, isShowFootnote }) => {
  return (
    <div className="info">
      <h3>{title}</h3>
      <div className="info__container">
        {infoItems.map((item) => {
          return (
            (item.value || item.button) && (
              <div
                key={`${item.label}${item.value}`}
                className={
                  item.button && item.label
                    ? `info__container__item info__container__item_with-button ${item.alignCenter ? 'center' : ''}`
                    : `info__container__item ${item.alignCenter ? 'center' : ''}`
                }
              >
                {item.label && (
                  <div className="info__container__item__text">
                    <article className="label">{item.label}</article>
                    {typeof item.value === 'object' ? (
                      <>
                        {item.value}
                        {moreDevices && isShowFootnote ? (
                          <article className="info__footnote">{moreDevices}</article>
                        ) : null}
                      </>
                    ) : (
                      <p className={`value ${item.className}`}>{item.value}</p>
                    )}
                  </div>
                )}
                {item.buttonShowPassword ? (
                  <div className="info__container__item btn">
                    <div className="info__container__item btn-password">{item.buttonShowPassword}</div>
                    {item.button}
                  </div>
                ) : (
                  item.button
                )}
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

Info.defaultProps = defaultProps;
